import { css } from "styled-components";

export * from "./_grid.style";
export * from "./_variables.styled";

export const maxLinesStyle = n => css`
	-webkit-line-clamp: ${n};
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
`

const parseHex = hex => parseInt(hex, 16)

export function hexToRgb(hex = '#000000') {
	// extract RGB values
	const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
		// normalize to full hex format `#RGB → #RRGGBB`
		hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_, r, g, b) => r + r + g + g + b + b)
	)
	return rgb ? {
			r: parseHex(rgb[1]),
			g: parseHex(rgb[2]),
			b: parseHex(rgb[3])
	} : null;
}

export function toRgb(hex, alpha = 1) {
	const rgb = hexToRgb(hex)
	if (!rgb) return ''
	const { r, g, b } = rgb
	return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function toHex(r, g, b) {
	/**
	 * `1 << 24` ensures that the result always has at least six hexadecimal
	 * digits by adding a leading bit that will be sliced off later. moves 8 bits
	 * left to each color component, bitwise `OR` combines them into a single integer.
	 */
	// eslint-disable-next-line no-mixed-operators
	return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
}

export const bgLinearGradientStyle = (hex = '#000000', opc = 1) => {
	const rgb = toRgb(hex, opc)
	const alpha = toRgb(hex, opc / 2)
	const transparent = toRgb(hex, 0)
	return (direction) => {
		switch(direction) {
			case 'top': return css`background-image: linear-gradient(to top, ${transparent} 50%, ${rgb} 156%);`
			case 'bottom': return css`background-image: linear-gradient(to bottom, ${transparent} 50%, ${rgb} 156%);`
			case 'both': return css`background-image: linear-gradient(0.28deg, ${alpha} 0.25%, ${transparent} 51.69%, ${alpha} 99.75%);`
			case 'none':
			default: return css`background-image: linear-gradient(to bottom, ${transparent} 50%, ${transparent} 156%);`
		}
	}
}

export const bgLinearGradientStyleBySuffix = (hex, opc) => {
	const bgLinearGradient = bgLinearGradientStyle(hex, opc)
	return css`
		&--bglinear__top {
			${bgLinearGradient('top')}
		}
		&--bglinear__bottom {
			${bgLinearGradient('bottom')}
		}
		&--bglinear__both {
			${bgLinearGradient('both')}
		}
		&--bglinear__none {
			${bgLinearGradient()}
		}
	`
}
